import "./App.css";
import { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { trackPageView } from "./utils/analytics";
import MyDocuments from "./components/features/Documents/myDocuments/MyDocuments";
import DocFormTestRunNew from "./components/features/Documents/docForm/TestRunNew.js";
import PropertyDocuments from "./components/features/Documents/propertyDocuments/PropertyDocuments.js";
import LandingPage from "./components/LandingPage";
import "./stylesheets/Custom.css";
import AboutPage from "./components/AboutPage";
import PolicyPage from "./components/PolicyPage";
import Signup from "./components/features/user/Signup";
import Login from "./components/features/user/Login";
import Dashboard from "./components/Dashboard";
import DashboardDocuments from "./components/dashboard/DashboardDocuments";
import ProtectedRoute from "./components/ProtectedRoute";
import AuthLayoutWrapper from "./components/AuthLayoutWrapper";
import MyDocumentForms from "./components/features/Documents/myDocuments/Records.js";
import MyDocFormViewFilled from "./components/features/Documents/myDocuments/ViewFilled.js";
import ViewAllDocuments from "./components/features/Documents/propertyDocuments/ViewAllDocuments.js";
import OtpVerification from "./pages/otpVerification.js";
import ProfilePage from "./components/ProfilePage";

function App() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return (
    <Routes>
      <Route path="/home" element={<LandingPage />} />
      <Route path="/About" element={<AboutPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route
        path="/about-us"
        element={<PolicyPage type="aboutus" title="About Us" />}
      />
      <Route
        path="/disclaimer"
        element={<PolicyPage type="disclaimer" title="Disclaimer" />}
      />
      <Route
        path="/contact-us"
        element={<PolicyPage title="Contact Us" type="contactUs" />}
      />
      <Route
        path="/terms-conditions"
        element={<PolicyPage type="terms" title="Terms & Conditions" />}
      />
      <Route
        path="/privacy-policy"
        element={<PolicyPage type="privacy" title="Privacy Policy" />}
      />
      <Route
        path="/ipr-copyright"
        element={<PolicyPage type="ipr" title="IPR & Copyright" />}
      />
      <Route
        path="/refund-cancellation"
        element={<PolicyPage type="refund" title="Refund & Cancellation" />}
      />
      <Route path="/dashboard" element={<Navigate to="/" replace />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/otp" element={<OtpVerification />} />
      <Route path="/login" element={<Login />} />
      <Route path="/documents" element={<PropertyDocuments />} />
      <Route
        path="/documents/view-all/:categoryId"
        element={<ViewAllDocuments />}
      />
      <Route
        exact
        path="/docFormTestRunNew"
        element={
          <AuthLayoutWrapper>
            <DocFormTestRunNew />
          </AuthLayoutWrapper>
        }
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardDocuments />} />
        <Route path="/my-documents" element={<MyDocuments />} />
        <Route path="/myDocForms" element={<MyDocumentForms />} />
        <Route path="/myDocFormViewFilled" element={<MyDocFormViewFilled />} />
        <Route path="/profile" element={<ProfilePage />} />
      </Route>
      {/* <Route path="/myDocForms" element={<ProtectedRoute><AuthLayoutWrapper><MyDocumentForms /></AuthLayoutWrapper></ProtectedRoute>} /> */}
    </Routes>
  );
}

export default App;
